import { Alert, Grid, SxProps } from '@mui/material';

interface InfoBoxProps {
  visible?: boolean;
  showIcon?: boolean;
  sx?: SxProps;
  children?: React.ReactNode;
}

export const InfoBox = ({
  visible = true,
  showIcon = true,
  sx,
  children,
}: InfoBoxProps) => {
  return visible ? (
    <Grid container>
      <Alert
        severity="info"
        {...(!showIcon && { icon: false })}
        sx={{ flexGrow: 1, ...sx }}>
        {children}
      </Alert>
    </Grid>
  ) : null;
};
